import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { useLang } from "@/lib/i18n";

export default function Terms() {
  const { t, lang } = useLang();
  return (
    <LegalLayout title={t("legal.terms.title")} updated={t("legal.terms.updated")} testid="terms-page" path="/agb">
      {lang === "de" ? <De /> : <En />}
    </LegalLayout>
  );
}

const De = () => (
  <>
    <h2>§ 1 Geltungsbereich</h2>
    <p>
      Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für sämtliche Verträge
      zwischen der X10 Management GmbH (nachfolgend „Auftragnehmer") und ihren Kunden
      (nachfolgend „Auftraggeber") über Beratungs-, Implementierungs- und
      Schulungsleistungen. Abweichende Bedingungen des Auftraggebers werden nicht
      anerkannt, es sei denn, der Auftragnehmer stimmt ihrer Geltung ausdrücklich
      schriftlich zu.
    </p>

    <h2>§ 2 Vertragsgegenstand</h2>
    <p>
      Gegenstand des Vertrages sind die im jeweiligen Angebot bzw. Auftrag konkret
      bezeichneten Beratungsleistungen. Der Auftragnehmer schuldet die fachgerechte
      Erbringung der vereinbarten Leistungen, jedoch keinen bestimmten wirtschaftlichen
      Erfolg, soweit nicht ausdrücklich anders vereinbart.
    </p>

    <h2>§ 3 Mitwirkungspflichten</h2>
    <p>
      Der Auftraggeber stellt dem Auftragnehmer alle für die Leistungserbringung
      erforderlichen Informationen, Unterlagen und Mittel rechtzeitig und vollständig
      zur Verfügung und benennt einen verantwortlichen Ansprechpartner.
    </p>

    <h2>§ 4 Vergütung und Zahlungsbedingungen</h2>
    <p>
      Die Vergütung richtet sich nach dem jeweiligen Angebot. Sofern nichts anderes
      vereinbart ist, wird monatlich nach Leistungserbringung abgerechnet.
      Rechnungsbeträge sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zur
      Zahlung fällig. Sämtliche Preise verstehen sich zzgl. der gesetzlichen
      Umsatzsteuer.
    </p>

    <h2>§ 5 Vertraulichkeit</h2>
    <p>
      Beide Vertragsparteien verpflichten sich, alle ihnen im Rahmen der
      Vertragsdurchführung bekannt gewordenen vertraulichen Informationen geheim zu
      halten und ausschließlich zu vertraglich vereinbarten Zwecken zu verwenden. Diese
      Pflicht besteht über die Beendigung des Vertrages hinaus fort.
    </p>

    <h2>§ 6 Nutzungsrechte</h2>
    <p>
      An den im Rahmen der Beratungstätigkeit erstellten Arbeitsergebnissen erwirbt der
      Auftraggeber mit vollständiger Bezahlung der vereinbarten Vergütung ein
      nicht-ausschließliches, übertragbares Nutzungsrecht für eigene
      Geschäftszwecke. Konzepte, Methoden und Standardbausteine verbleiben beim
      Auftragnehmer.
    </p>

    <h2>§ 7 Haftung</h2>
    <p>
      Der Auftragnehmer haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie
      bei Verletzung von Leben, Körper und Gesundheit. Bei einfacher Fahrlässigkeit
      haftet der Auftragnehmer nur für die Verletzung wesentlicher Vertragspflichten
      (Kardinalpflichten) und auch nur in Höhe des bei Vertragsschluss vorhersehbaren,
      vertragstypischen Schadens.
    </p>

    <h2>§ 8 Laufzeit und Kündigung</h2>
    <p>
      Sofern nicht anders vereinbart, können Beratungsverträge von beiden
      Vertragsparteien mit einer Frist von vier Wochen zum Monatsende ordentlich
      gekündigt werden. Das Recht zur außerordentlichen Kündigung aus wichtigem Grund
      bleibt unberührt. Kündigungen bedürfen der Schriftform.
    </p>

    <h2>§ 9 Datenschutz</h2>
    <p>
      Beide Parteien verpflichten sich zur Einhaltung der jeweils geltenden
      datenschutzrechtlichen Bestimmungen. Sofern erforderlich, schließen die Parteien
      einen separaten Vertrag zur Auftragsverarbeitung.
    </p>

    <h2>§ 10 Schlussbestimmungen</h2>
    <p>
      Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss
      des UN-Kaufrechts. Ausschließlicher Gerichtsstand ist – soweit gesetzlich
      zulässig – Bochum. Sollten einzelne Bestimmungen unwirksam sein, bleibt die
      Wirksamkeit der übrigen Bestimmungen unberührt.
    </p>
  </>
);

const En = () => (
  <>
    <h2>§ 1 Scope</h2>
    <p>These Terms apply to all contracts between X10 Management GmbH ("Contractor") and clients on consulting, implementation and training services. Deviating client terms are not accepted unless expressly confirmed in writing.</p>

    <h2>§ 2 Subject of contract</h2>
    <p>The subject of the contract is the consulting services specifically described in the respective offer or order.</p>

    <h2>§ 3 Cooperation duties</h2>
    <p>The client provides all necessary information, documents and resources in time and names a responsible contact person.</p>

    <h2>§ 4 Compensation and payment</h2>
    <p>Compensation follows the respective offer. Unless otherwise agreed, invoicing is monthly. Invoices are due within 14 days net. All prices exclude statutory VAT.</p>

    <h2>§ 5 Confidentiality</h2>
    <p>Both parties keep confidential information secret and use it only for the agreed purposes. The obligation survives termination.</p>

    <h2>§ 6 Usage rights</h2>
    <p>Upon full payment, the client receives a non-exclusive, transferable right to use the work results for its own business purposes. Methods, concepts and standard building blocks remain with the contractor.</p>

    <h2>§ 7 Liability</h2>
    <p>The contractor is unlimitedly liable for intent and gross negligence and for injury to life, body and health. For simple negligence, liability is limited to essential contractual obligations and the foreseeable, contract-typical damage.</p>

    <h2>§ 8 Term and termination</h2>
    <p>Unless otherwise agreed, contracts can be terminated by either party with four weeks' notice to the end of the month. Termination for cause remains unaffected. Written form required.</p>

    <h2>§ 9 Data protection</h2>
    <p>Both parties comply with applicable data protection law. Where necessary, a separate data processing agreement is concluded.</p>

    <h2>§ 10 Final provisions</h2>
    <p>German law applies, excluding UN sales law. Place of jurisdiction is Bochum, where legally permissible. Severability clause applies.</p>
  </>
);
